import { Component, EventEmitter, Input, OnInit } from '@angular/core';

@Component({
  standalone: false,
  selector: 'ti-compare-info-block',
  templateUrl: './compare-info-block.component.html',
  styleUrls: ['./compare-info-block.component.sass'],
})
export class CompareInfoBlockComponent implements OnInit {
  @Input() version1: string;
  @Input() compareInfo: string;
  @Input() version2: string;
  load: EventEmitter<boolean> = new EventEmitter(false);
  constructor() {}

  ngOnInit() {}
}
